import React from 'react';
import {
   StyleSheet,
   SafeAreaView,
   View,
   TouchableOpacity,
   Image,
   Text,
   Platform,
} from 'react-native';
import {
   drawerListBackgroundColor,
   getNavBarHeight,
   FONT_FAMILY_REGULAR,
   appBackground,
   white,
   setWebNavTitle,
   BACK_ARROW_HOVER_TINT_COLOR,
} from './utils';
import {useNavigation, useRoute} from '@react-navigation/native';
import {CustomStatusBar} from './customStatusBar';
import PDFViewer from './pdfViewer';
import {
   selectLandscapeSmallWebView,
   selectScreenOrientation,
} from '../redux/slices/ScreenOrientationSlice';
import {selectUserRecord} from '../redux/slices/UserRecordSlice';
import {selectAuthData} from '../redux/slices/AuthSlice';
import {useSelector} from 'react-redux';
//import RNFS from 'react-native-fs';
import RNFS from '../components/fs';
//import Share from 'react-native-share';
import Share from '../components/share';
import {PermissionsAndroid} from 'react-native';
import logger from './logger';

export const WebViewContainer = props => {
   const navigation = useNavigation();
   const params = useRoute().params;
   const isLandscapemode = useSelector(selectScreenOrientation);
   const record = useSelector(selectUserRecord);
   const authData = useSelector(selectAuthData);
   React.useLayoutEffect(() => {
      setWebNavTitle(navigation, params?.title ?? 'Advertizement');
   }, [navigation]);
   const requestStoragePermission = async () => {
      if (Platform.OS === 'web') {
         return;
      }
      try {
         const granted = await PermissionsAndroid.request(
            PermissionsAndroid.PERMISSIONS.WRITE_EXTERNAL_STORAGE,
            {
               title: 'Storage Permission',
               message:
                  'App needs access to your storage to download the file.',
               buttonPositive: 'OK',
               buttonNegative: 'Cancel',
            },
         );
         return granted === PermissionsAndroid.RESULTS.GRANTED;
      } catch (error) {
         console.error('Error requesting storage permission:', error);
         return false;
      }
   };

   const downloadAndSavePDF = async (base64Data, fileName) => {
      if (Platform.OS === 'web') {
         const d = new Date();
         let ms = d.getMilliseconds();
         const name = fileName.replace('Print', '') + ms + '.pdf';
         const userAgent = window.navigator.userAgent;
         if (userAgent.includes('iPhone OS')) {
            const pdfData = base64Data.substring(28);
            const blob = new Blob(
               [Uint8Array.from(atob(pdfData), c => c.charCodeAt(0))],
               {type: 'application/pdf'},
            );
            const pdfUrl = URL.createObjectURL(blob);
            window.open(pdfUrl, '_blank');
         } else {
            const downloadLink = document.createElement('a');
            downloadLink.href = base64Data;
            downloadLink.download = name;
            downloadLink.click();
         }
         /* if (record.UserKey && record.CourseType && authData.EmployeeKey) {
            const downloadRecord =
               BASE_URL +
               'getDocument?r=' +
               record.UserKey +
               '&c=' +
               record.CourseType +
               '&n=' +
               authData.EmployeeKey;
            Share.share(
               {
                  title: 'Certificate',
                  message: record.CourseName,
                  subject: 'Download Certificate',
                  url: downloadRecord,
               },
               {dialogTitle: 'Android Title'},
            )
               .then(({action, activityType}) => {
                  logger({action, activityType});
                  if (action === Share.sharedAction) {
                     logger('Share was successful');
                  } else {
                     logger('Share was dismissed');
                  }
               })
               .catch(err => logger(err));
         } */
      } else {
         const d = new Date();
         let ms = d.getMilliseconds();
         const name = fileName.replace('Print', '') + ms + '.pdf';
         if (Platform.OS === 'android') {
            const granted = await requestStoragePermission();
            if (!granted) {
               console.warn('Storage permission denied.');
               return;
            }
         }
         var path;
         if (Platform.OS === 'ios') {
            path = `${RNFS.DocumentDirectoryPath}/${name}`;
         } else if (Platform.OS === 'android') {
            path = `${RNFS.DownloadDirectoryPath}/${name}`;
         } else {
            // Unsupported platform
            return;
         }

         try {
            await RNFS.writeFile(
               path,
               base64Data.replace('application/pdf;base64,', ''),
               'base64',
            );

            logger('File saved:', path);
            // Share the PDF file using react-native-share
            Share.open({
               url: `file://${path}`,
               type: 'application/pdf',
            })
               .then(() => {
                  logger('PDF shared successfully', false);
               })
               .catch(error => {
                  logger('Error sharing PDF:', error, false);
               });
         } catch (error) {
            console.error('Error saving file:', error);
         }
      }
   };

   const isWeb = Platform.OS === 'web';
   const isLandscapeSmallWebView = useSelector(selectLandscapeSmallWebView);
   const [backHover, setBackHover] = React.useState(false);
   const [dwnBtnHover, setDwnBtnBackHover] = React.useState(false);
   return (
      <SafeAreaView
         style={[
            styles.container,
            {
               ...Platform.select({
                  web: {
                     flex: null,
                     /* height: !isLandscapemode
                        ? isLandscapeSmallWebView
                           ? '100%'
                           : '100vh'
                        : '100vh', */
                     minHeight: isLandscapeSmallWebView ? '100vh' : null,
                     overflowY: isLandscapemode ? 'hidden' : 'auto',
                  },
               }),
            },
         ]}>
         <CustomStatusBar
            backgroundColor={drawerListBackgroundColor}
            barStyle="light-content"
         />
         <View
            style={{
               flexDirection: 'row',
               alignItems: 'center',
               height: !isLandscapemode ? getNavBarHeight() : 88,
               minHeight: 88,
               backgroundColor: drawerListBackgroundColor,
               justifyContent: 'space-between',
               ...Platform.select({
                  web: {
                     minHeight: 88,
                     minWidth: '100%',
                  },
               }),
            }}>
            <View
               style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  cursor: 'pointer',
               }}>
               <TouchableOpacity
                  style={{padding: 10, marginTop: 0}}
                  onMouseEnter={() => {
                     setBackHover(true);
                  }}
                  onMouseLeave={() => {
                     setBackHover(false);
                  }}
                  onPress={() => {
                     props.navigation.goBack();
                  }}>
                  <Image
                     source={require('../assets/back_arrow.png')}
                     style={{
                        width: !isLandscapemode ? 16 : 24,
                        height: !isLandscapemode ? 16 : 24,
                        marginLeft: !isLandscapemode ? 7 : 10,
                        tintColor: backHover
                           ? BACK_ARROW_HOVER_TINT_COLOR
                           : '#FFF',
                     }}
                  />
               </TouchableOpacity>
            </View>

            {params.apiAction && (
               <View
                  style={{flexDirection: 'row-reverse', alignItems: 'center'}}>
                  <TouchableOpacity
                     style={{padding: 10, marginTop: 0}}
                     onMouseEnter={() => {
                        setDwnBtnBackHover(true);
                     }}
                     onMouseLeave={() => {
                        setDwnBtnBackHover(false);
                     }}
                     onPress={() => {
                        downloadAndSavePDF(params.urlPath, params.apiAction);
                     }}>
                     <Image
                        source={
                           Platform.OS === 'web'
                              ? require('../assets/document-download.png')
                              : require('../assets/share.png')
                        }
                        style={{
                           width: 24,
                           height: 24,
                           marginEnd: 10,
                           ...Platform.select({
                              web: {
                                 marginStart: 10,
                                 tintColor: dwnBtnHover
                                    ? BACK_ARROW_HOVER_TINT_COLOR
                                    : '#FFF',
                                 width: isLandscapeSmallWebView ? 18 : 24,
                                 height: isLandscapeSmallWebView ? 18 : 24,
                              },
                           }),
                        }}
                     />
                  </TouchableOpacity>
               </View>
            )}
         </View>
         {params.isShowingByBase64Str ? (
            <View
               style={{
                  marginVertical: '5%',
                  alignItems: 'center',
               }}>
               <View
                  style={{
                     backgroundColor: 'white',
                     shadowColor: 'black',
                     shadowOffset: {width: 0, height: 1},
                     shadowOpacity: 0.2,
                     shadowRadius: 20,
                     elevation: 5,
                     width: '90%',
                     height: '100%',
                  }}>
                  <PDFViewer
                     urlPath={params.urlPath}
                     isShowingByBase64Str={params.isShowingByBase64Str}
                  />
               </View>
            </View>
         ) : (
            <PDFViewer
               urlPath={params.urlPath}
               isShowingByBase64Str={params.isShowingByBase64Str}
            />
         )}
      </SafeAreaView>
   );
};

const styles = StyleSheet.create({
   container: {
      flex: 1,
      backgroundColor: drawerListBackgroundColor,
      justifyContent: 'center',
      alignItems: 'center',
      ...Platform.select({
         web: {
            flex: null,
            backgroundColor: white,
            width: '100%',
            //minHeight: '98vh',
         },
      }),
   },
});
